import { FieldContainer } from 'v2/core/entities/fields';

const useGetStaticFields = (): {
  fields: Pick<FieldContainer, 'EntitySentiment'>;
} => {
  return {
    fields: {
      EntitySentiment: undefined,
    },
  };
};
export default useGetStaticFields;
